import React from 'react'

import { useVisitorMarket } from '../../../hooks/useVisitorMarket'
import { DEFAULT_EXAMPLE_INVOICE_IMAGE_URL } from '../../../lib/exampleInvoiceImage'
import imageAu from '../../../static/images/invoices/example-invoice-au.png'
import imageCa from '../../../static/images/invoices/example-invoice-ca.png'
import imageEs from '../../../static/images/invoices/example-invoice-es.png'
import imageUk from '../../../static/images/invoices/example-invoice-uk.png'
import imageUs from '../../../static/images/invoices/example-invoice-us.png'
import type { MarketCode } from '../../../lib/markets'

const IMAGE_BY_MARKET: Record<MarketCode, string> = {
  US: imageUs,
  GB: imageUk,
  CA: imageCa,
  ES: imageEs,
  AU: imageAu,
}

type Props = {
  className?: string
  alt?: string
  /** Pre-rendered static homepage: src updated by build-injected script. */
  staticMode?: boolean
}

const ExampleInvoiceImage: React.FC<Props> = ({
  className,
  alt = 'TinyInvoice.app invoice example',
  staticMode = false,
}) => {
  if (staticMode) {
    return (
      <img
        id='how-it-works-example-image'
        src={DEFAULT_EXAMPLE_INVOICE_IMAGE_URL}
        alt={alt}
        className={className}
      />
    )
  }

  return <ExampleInvoiceImageClient className={className} alt={alt} />
}

const ExampleInvoiceImageClient: React.FC<{ className?: string; alt: string }> = ({
  className,
  alt,
}) => {
  const { market } = useVisitorMarket()
  const src = market?.code ? IMAGE_BY_MARKET[market.code] : imageUs

  return <img src={src} alt={alt} className={className} />
}

export default ExampleInvoiceImage
